import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { UbsViewContainersModule, ViewContainersService } from '@urbannex/view-containers';
import { NbMenuItem, NbMenuService } from '@nebular/theme';
import { ShippingComponent } from './shipping.component';
import { QuantityBreaksComponent } from './quantity-breaks/quantity-breaks.component';
import { CarrierMethodsComponent } from './carrier-methods/carrier-methods.component';
import { TimeEstimatesComponent } from './time-estimates/time-estimates.component';

export const shippingRoutes: Routes = [
  {
    path:'',
    component:ShippingComponent,
    children:[
      {
        path:'shipment-method',
        component:ShippingComponent
      }
    ] 
  },
  {
    path:'shipment-method/:shipmentMethodTypeId',
    component:ShippingComponent
  },
  {
    path:'quantities',
    component:QuantityBreaksComponent
  },
  {
    path:'quantities/:quantityBreakId',
    component:QuantityBreaksComponent
  },
  {
    path:'carriers',
    component:CarrierMethodsComponent
  },
  {
    path:'carriers/carrierShipmentMethods',
    component:CarrierMethodsComponent
  },
  {
    path:'time-estimates',
    component:TimeEstimatesComponent
  },
  {
    path:'time-estimates/carrier-times',
    component:TimeEstimatesComponent
  }
]

export const baseMenuItems:NbMenuItem[] = [
  {
      title:"Shipping Management",
      group:true
  },
  {
      title:"Shipment Method Types",
      icon:"list-outline",
      link:"/admin/img/product-galleries",
      data:{
          event:"list",
          type:"ListProductCategoryMembers",
          data:{
          formData:{
              formName:"ListProductCategoryMembers",
              formLocation:"component://kwikstore/widget/ImageManagementForms.xml"
          },
          appContext:"catalog",
          }
      }
  },
  {
    title:"Quantity Breaks",
    icon:"list-outline",
    link:"/admin/img/product-galleries",
    data:{
        event:"list",
        type:"ListProductCategoryMembers",
        data:{
        formData:{
            formName:"ListProductCategoryMembers",
            formLocation:"component://kwikstore/widget/ImageManagementForms.xml"
        },
        appContext:"catalog",
        }
    }
  },
  {
    title:"Carrier Shipment Methods",
    icon:"list-outline",
    link:"/admin/img/product-galleries",
    data:{
        event:"list",
        type:"ListProductCategoryMembers",
        data:{
        formData:{
            formName:"ListProductCategoryMembers",
            formLocation:"component://kwikstore/widget/ImageManagementForms.xml"
        },
        appContext:"catalog",
        }
    }
  },
  {
    title:"Shipment Time Estimates",
    icon:"list-outline",
    link:"/admin/img/product-galleries",
    data:{
        event:"list",
        type:"ListProductCategoryMembers",
        data:{
        formData:{
            formName:"ListProductCategoryMembers",
            formLocation:"component://kwikstore/widget/ImageManagementForms.xml"
        },
        appContext:"catalog",
        }
    }
  }
]

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    RouterModule.forChild(shippingRoutes),
    UbsViewContainersModule
  ]
})
export class ShippingRoutingModule {
  menuItems:NbMenuItem[] = [];
  headerTitle:string = "Shipping";
  path:string = "shipping";
  menuTag:string = "shippingMenu"
  menuAndTitleOptions = {path:this.path,menuItems:baseMenuItems,headerTitle:this.headerTitle,menuTag:this.menuTag};

  constructor(
    private viewContainerService:ViewContainersService,
    private menuService:NbMenuService){
      this.viewContainerService.menuAndTitleOptions$.next([... this.viewContainerService.menuAndTitleOptions$.getValue(),this.menuAndTitleOptions]);
    this.viewContainerService.activeMenuTag$.next(this.menuTag);
    /* baseMenuItems.forEach(item => {
      this.menuItems.push(item);
    }); */
    //this.menuService.addItems(this.menuItems,this.menuTag);
  }
 }
